import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Paper,
} from '@mui/material';
import { loginToHrms } from '../services/apiServices';
import { authClient } from "../lib/auth-client";

console.log(process.env.REACT_APP_CALLBACK_URL, 'callbackurl----')

console.log("test")
function SignInPage({ onSignIn }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const result = await loginToHrms(username, password);
      localStorage.setItem('hrmsResponse', JSON.stringify(result));
      onSignIn();
    } catch (err) {
      console.error('Login failed:', err);
      setError('Invalid credentials. Please try again.');
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={4} sx={{ p: 4 }}>
          <Box textAlign="center" mb={4}>
            <Typography
              variant="h4"
              noWrap
              fontWeight="bold"
              sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              Welcome to{' '}
              <span style={{ color: '#1976d2' }}>GitMetrics</span>
            </Typography>

            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Visualize and analyze your team's Git activity with insights.
            </Typography>

          </Box>

          <form onSubmit={handleSubmit}>
            <Button
              variant="outlined"
              fullWidth
              sx={{ mt: 2 }}
              onClick={async () => {
                await authClient.signIn.social({
                  provider: "microsoft",
                  callbackURL: process.env.REACT_APP_CALLBACK_URL,
                });
              }}
            >
              Sign in with Microsoft
            </Button>

          </form>
        </Paper>
      </Container>
    </Box>
  );
}

SignInPage.propTypes = {
  onSignIn: PropTypes.func.isRequired,
};

export default SignInPage;
